import React from "react";
import Button from "@mui/material/Button";
import AddIcon from "@mui/icons-material/Add";
import RemoveIcon from "@mui/icons-material/Remove";
import CampaignIcon from "@mui/icons-material/Campaign";
import AssignmentIcon from "@mui/icons-material/Assignment";
import "./button.scss";
import commonImages from "../../../assets";

export default function Buttons({
  label,
  variantOutline,
  varientContained,
  varientText,
  onClick,
  varientTextGreen,
  disabled,
  primary,
  startIcon,
  type,
  redBg,
  id,
  variantOutlineSections,
  redButton,
  varientAddIconBlue,
  primaryalert,
  primaryassign,
  varientContainedExport,
  primaryalertAll,
  variantOutlineBorder = false,
  iconToggle = false,
  varientContainedGrey = false,
  testId,
}) {
  const resolvedTestId = testId || id || (label ? `btn-${label.replace(/\s+/g, '-').toLowerCase()}` : undefined);
  return (
    <div className="overideBtn">
      {varientText && (
        <Button
          disabled={disabled}
          className="textButton"
          variant="text"
          onClick={onClick}
          data-testid={resolvedTestId}
        >
          {label}
        </Button>
      )}
      {varientContained && (
        <Button
          id={id}
          disabled={disabled}
          className="containedButton"
          variant="contained"
          onClick={onClick}
          fullWidth={true}
          type={type}
          data-testid={resolvedTestId}
        >
          {label}
        </Button>
      )}
      {variantOutline && (
        <Button
          disabled={disabled}
          variant="outlined"
          className="outlinedButton"
          onClick={onClick}
          data-testid={resolvedTestId}
          id={id}
        >
          {label}
        </Button>
      )}
      {variantOutlineSections && (
        <Button
          disabled={disabled}
          variant="outlined"
          className="outlinedButton"
          onClick={onClick}
          startIcon={
            <AddIcon className={disabled ? "addIconGrey" : "addIconBtnsblue"} />
          }
          data-testid={resolvedTestId}
          id={id}
        >
          {label}
        </Button>
      )}
      {varientTextGreen && (
        <Button
          variant="text"
          disabled={disabled}
          startIcon={
            <AddIcon className={disabled ? "addIconGrey" : "addIconBtn"} />
          }
          className="varientTextGreens"
          onClick={onClick}
          data-testid={resolvedTestId}
          id={id}
        >
          {label}
        </Button>
      )}
      {primary && (
        <Button
          disabled={disabled}
          className={["primary_btn_style", redBg && "red_bg"].join(" ")}
          variant="text"
          onClick={onClick}
          startIcon={startIcon}
          data-testid={resolvedTestId}
          id={id}
        >
          {label}
        </Button>
      )}
      {primaryalert && (
        <Button
          disabled={disabled}
          className={["primaryalert_btn_style", redBg && "red_bg"].join(" ")}
          variant="text"
          onClick={onClick}
          startIcon={<CampaignIcon className="addIconalertBtns" />}
          data-testid={resolvedTestId}
          id={id}
        >
          {label}
        </Button>
      )}
      {primaryalertAll && (
        <Button
          disabled={disabled}
          className={["primaryalertAll_btn_style", redBg && "red_bg"].join(" ")}
          variant="text"
          onClick={onClick}
          startIcon={<CampaignIcon className="addIconalertBtns" />}
          data-testid={resolvedTestId}
          id={id}
        >
          {label}
        </Button>
      )}
      {primaryassign && (
        <Button
          disabled={disabled}
          className={["primaryassign_btn_style", redBg && "red_bg"].join(" ")}
          variant="text"
          onClick={onClick}
          startIcon={<AssignmentIcon className="addIconalertBtns" />}
          data-testid={resolvedTestId}
          id={id}
        >
          {label}
        </Button>
      )}
      {redButton && (
        <Button
          id={id}
          disabled={disabled}
          className="redBtn"
          variant="contained"
          onClick={onClick}
          fullWidth={true}
          type={type}
          data-testid={resolvedTestId}
        >
          {label}
        </Button>
      )}
      {varientAddIconBlue && (
        <Button
          id={id}
          disabled={disabled}
          className="containedButton"
          variant="contained"
          onClick={onClick}
          startIcon={
            iconToggle ? (
              <RemoveIcon className="addIconBtns" />
            ) : (
              <AddIcon className="addIconBtns" />
            )
          }
          fullWidth={true}
          type={type}
          data-testid={resolvedTestId}
        >
          {label}
        </Button>
      )}

      {varientContainedExport && (
        <Button
          id={id}
          disabled={disabled}
          className="containedButtonExport"
          variant="contained"
          onClick={onClick}
          fullWidth={true}
          type={type}
          startIcon={<img src={commonImages.downloadcategoryIcon} />}
          data-testid={resolvedTestId}
        >
          {label}
        </Button>
      )}

      {variantOutlineBorder && (
        <Button
          disabled={disabled}
          variant="outlined"
          className="outlinedButton"
          onClick={onClick}
          startIcon={
            iconToggle ? (
              <RemoveIcon
                className={disabled ? "addIconGrey" : "addIconBtnsblue"}
              />
            ) : (
              <AddIcon
                className={disabled ? "addIconGrey" : "addIconBtnsblue"}
              />
            )
          }
          data-testid={resolvedTestId}
          id={id}
        >
          {label}
        </Button>
      )}
      {varientContainedGrey && (
        <Button
          id={id}
          disabled={disabled}
          className="containedButtonGrey"
          variant="contained"
          onClick={onClick}
          fullWidth={true}
          type={type}
          data-testid={resolvedTestId}
        >
          {label}
        </Button>
      )}
    </div>
  );
}
